import TreeOrg from './tree-org.vue'

/* istanbul ignore next */
TreeOrg.install = function (Vue) {
  Vue.component(TreeOrg.name, TreeOrg)
}

export default TreeOrg
